var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"title":_vm.title,"placement":_vm.placement,"closable":false,"visible":_vm.visible,"height":_vm.height},on:{"close":_vm.onClose}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }